import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    items: [],
    loading: false,
    error: null,
}

const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        fetchProductsStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchProductsSuccess(state, action) {
            state.items = action.payload;
            state.loading = false;
        },
        fetchProductsFailure(state, action) {
            state.error = action.payload;
            state.loading = false;
        },
        clearSearchResults(state) {
            state.items = []
        }
    }
});

export const {fetchProductsStart, fetchProductsSuccess, fetchProductsFailure, clearSearchResults } = searchSlice.actions;

export default searchSlice.reducer;

export const fetchProducts = (searchProduct, storeCode, agentCodeOrPhone, customer_id, barCode, ) => async (dispatch) => {
    
    if (!barCode && !searchProduct.trim()) {
        dispatch(clearSearchResults());
        return
    };

    dispatch(fetchProductsStart());

    try {
        const response = await axios.post(
            'https://mcstaging.candere.com/rest/V1/pos-productmanagement/productsearch',
            JSON.stringify({
              "storeCode": storeCode,
              "agentCode": agentCodeOrPhone,
              "customerId": customer_id,
              "searchTerm": searchProduct,
              "barcode": "",
              "pageSize":"12",
              "page":1,
            }),
            {
              headers: { 
                  'Content-Type': 'application/json', 
                  'Authorization': 'Bearer 9tcpn4uq9my8ymfj0qbdsscld9pqzlta', 
              },
              withCredentials: true,
            }
        );

        dispatch(fetchProductsSuccess(response.data.products)); 
    } catch (error) {
        dispatch(fetchProductsFailure(error.message));
    }
}